export default __webpack_public_path__ + "static/media/THA.cb240082.svg";